import { WsAvatarProps } from './types';

export function WsAvatar({ photoURL, size = 'small', 'data-testid': testId }: WsAvatarProps) {
  const sizeClasses = size === 'small' ? 'h-8 w-8 min-w-8 min-h-8' : 'h-12 w-12 min-w-12';
  const classes = `inline-block overflow-hidden rounded-full ring-2 ring-white bg-gray-100 ${sizeClasses}`;

  return (
    <>
      {photoURL ? (
        <img className={classes} src={photoURL} alt="" data-testid={testId} />
      ) : (
        <span className={classes} data-testid={testId}>
          <svg className="h-full w-full text-gray-300" fill="currentColor" viewBox="0 0 24 24">
            <path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" />
          </svg>
        </span>
      )}
    </>
  );
}
export default WsAvatar;
